import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "../../components/common/Tabs";
import { accountTabs } from "../../utils/constants";
import { getDoctorDetails } from "../../redux/Thunk/Doctor/DoctorThunks";
import { useDispatch } from "react-redux";

import SidebarToggle from "../../components/Doctor/SidebarToggle";

const Account = ({ defaultTab: propDefaultTab }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const tabFromQuery = queryParams.get("tab");

  const effectiveDefaultTab = propDefaultTab || tabFromQuery || "Profile";

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(getDoctorDetails(token));
    }
  }, [dispatch]);

  return (
    <section className="w-full">
      <Tabs
        title="Account"
        tabs={accountTabs}
        prefix={<SidebarToggle className="!p-2 bg-gray-50 hover:bg-gray-100 text-gray-700 rounded-xl" />}
        defaultTab={effectiveDefaultTab}
      />
    </section>
  );
};

export default Account;
